const SpinnerButtom = ({}) => {
  return (
    <div class="inline-block max-h-[20px] min-h-[20px] max-w-[20px] min-w-[20px] animate-spin rounded-full border-[3px] border-solid border-current border-e-transparent align-middle text-surface motion-reduce:animate-spin_1.5s_linear_infinite text-blue-300 dark:text-white"/>
  );
};
export default SpinnerButtom;
